import { module } from 'stereomodularjs';
import { html } from '../utils/environment'

/* 
// USAGE :
<div class="c-tabs" data-module="Tabs">
    <div class="c-tabs-nav__wrap" role="tablist">
        <div class="c-tabs-nav-mobile">
            <button data-tabs="button" tabindex="0" data-tabs-dir="<" class="c-tabs-nav-mobile__button" role="tab">
                <?php svg('arrow-left'); ?>
            </button>
            <button data-tabs="button" tabindex="0" data-tabs-dir=">" class="c-tabs-nav-mobile__button" role="tab">
                <?php svg('arrow-right'); ?>
            </button>
        </div>
        <div class="c-tabs-nav" data-tabs="nav">
            <?php for ($i = 1; $i <= 3; $i++) : ?>
                <button class="c-tabs-nav__item" data-tabs="trigger" role="tab">
                    <span class="c-tab">
                        Tab <?= $i; ?>
                    </span>
                </button>
            <?php endfor; ?>
        </div>
    </div>
    <div class="c-tabs-content__wrap">
        <?php for ($i = 1; $i <= 3; $i++) : ?>
            <div class="c-tab-content__item" data-tabs="content">
                <div class="c-tab-content">
                    <h3>Titre tab <?= $i; ?></h3>
                    <p>Content tab <?= $i; ?></p>
                    <a href="/" class="o-button" title="Consulter la page <?= $i; ?>">
                        En savoir plus
                    </a>
                </div>
            </div>
        <?php endfor; ?>
    </div>
</div>
*/

const PARAM = {
    OPEN: `is-active`,
    OPENMOBILE: `is-mobile-active`,
    CLICK: `click`,
}

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                trigger: 'open',
                button: 'nextprev'
            },
            keydown: {
                trigger: 'browse'
            }
        }
    }

    setAttributes(el, attrs) {
        for (var key in attrs) {
            el.setAttribute(key, attrs[key]);
        }
    }

    resetAttributes() {
        let moduleEl = this.el
        let moduleId = moduleEl.getAttribute('data-mid')
        let tabsTriggers = moduleEl.querySelectorAll('[data-tabs="trigger"]')
        let tabsContents = moduleEl.querySelectorAll('[data-tabs="content"]')

        if (tabsTriggers.length != tabsContents.length) {
            console.error('Tabs : Number of triggers and contents does not match');
        }

        let i = 1;
        tabsTriggers.forEach(trigger => {
            this.setAttributes(trigger, {
                'id': moduleId + '-trigger-' + i,
                'aria-controls': moduleId + '-target-' + i,
                'aria-selected': "false",
                'tabindex': '-1'
            })

            i++;
        });

        let j = 1;
        tabsContents.forEach(content => {
            this.setAttributes(content, {
                'role': 'tabpanel',
                'aria-labelledby': moduleId + '-trigger-' + j,
                'id': moduleId + '-target-' + j,
                'tabindex': '0',
                'hidden': 'true'
            })

            j++;

            toggleChildsTabindex(content, '-1');
        });
    }

    init() {
        let moduleEl = this.el
        let moduleId = moduleEl.getAttribute('data-mid')
        let tabsTriggers = moduleEl.querySelectorAll('[data-tabs="trigger"]')
        let tabsContents = moduleEl.querySelectorAll('[data-tabs="content"]')

        // Init accessibility attr
        this.resetAttributes()

        // Set first child visible (Nav)
        this.setAttributes(tabsTriggers[0], {
            'aria-selected': 'true',
            'tabindex': '0',
        })

        // Set active first el
        tabsTriggers[0].classList.add('is-active')

        // Set first child visible (Content)
        tabsContents[0].removeAttribute('hidden')
        toggleChildsTabindex(tabsContents[0], '0');
    }

    /**
     * Open Action
     *
     * @param el {node}
     */
    open(el) {
        let curTrigger = false;
        //console.log(el);
        if (el != null && el.currentTarget) {
            curTrigger = el.currentTarget
        } else {
            curTrigger = el
        }
        let moduleEl = this.el
        let curContent = moduleEl.querySelector('#' + curTrigger.getAttribute('aria-controls'))
        let tabsNav = moduleEl.querySelector('[data-tabs="nav"]')

        let tabsNavItems = tabsNav.querySelectorAll('.is-active');
        if (tabsNavItems) {
            tabsNavItems.forEach(navItem => {
                navItem.classList.remove('is-active')
                classRemove(navItem, PARAM.OPEN)
                classRemove(curContent, PARAM.OPEN)
            })
        }

        // Reset attr
        this.resetAttributes();

        // Set active attr (Nav)
        this.setAttributes(curTrigger, {
            'aria-selected': 'true',
            'tabindex': '0',
        });

        // Set active attr (Content)
        curContent.removeAttribute('hidden')

        toggleChildsTabindex(curContent, '0');

        classAdd(curTrigger, PARAM.OPEN)
        classAdd(curContent, PARAM.OPEN)
        if (tabsNav.classList.contains(PARAM.OPENMOBILE)) {
            classRemove(tabsNav, PARAM.OPENMOBILE)
        } else {
            classAdd(tabsNav, PARAM.OPENMOBILE)
        }
    }

    nextprev(el) {
        let browseDir = el.currentTarget.getAttribute('data-tabs-dir')
        if (browseDir == "<") {
            this.browse(false, '<')
        } else {
            this.browse(false, '>')
        }
    }

    /**
     * Close Action
     *
     * @param
     */
    browse(el, dir) {
        let moduleEl = this.el
        let tabsTriggers = moduleEl.querySelectorAll('[data-tabs="trigger"]')
        let curEl = moduleEl.querySelectorAll('.is-active[data-tabs="trigger"]')[0]
        let lastTab = tabsTriggers[tabsTriggers.length - 1];
        let newActive = false;

        if (el.key || dir) {
            if (el.key === 'ArrowRight' || dir === '>') {
                if (curEl.nextElementSibling && curEl.nextElementSibling.classList.contains('c-tabs-nav__item')) {
                    newActive = curEl.nextElementSibling;
                } else {
                    newActive = tabsTriggers[0]
                }
            }
            if (el.key === 'ArrowLeft' || dir === '<') {
                if (curEl.previousElementSibling && curEl.previousElementSibling.classList.contains('c-tabs-nav__item')) {
                    newActive = curEl.previousElementSibling;
                } else {
                    newActive = lastTab;
                }
            }
            if (newActive) {
                //console.log('newActive!');
                curEl.setAttribute("tabindex", -1);
                curEl.classList.remove('is-active');

                newActive.setAttribute("tabindex", 0);
                newActive.classList.add('is-active');
                //console.log(newActive);
                this.open(newActive)
                if (!dir) {
                    newActive.focus();
                }
            }
        }
    }

    destroy() {
        // Remove event listeners
        this.tabs.forEach((tab) => {
            tab.removeEventListener('click', this.handleTabClick);
        });

        // Revert DOM changes
        const activeTab = this.el.querySelector('.is-active');
        if (activeTab) {
            activeTab.classList.remove('is-active');
            activeTab.removeAttribute('tabindex');
        }
    }
}
